import { useState } from "react";
import { JandiSymbol } from "../assets/logos/svgs";
import { AnimatePresence, motion } from "framer-motion";
import useDimension from "@/hooks/use-dimension";
import { useTranslation } from "react-i18next";

const JandiHelp = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const { width } = useDimension();
  const isMobile = width < 425;

  return (
    <motion.div
      style={{
        position: "fixed",
        zIndex: 999,
        padding: 2,
        border: "2px solid #FFF",
        borderRadius: "50%",
        bottom: isMobile ? "8vw" : "3vw",
        right: isMobile ? "8vw" : "3vw",
      }}
    >
      <AnimatePresence mode="sync">
        {open && (
          <motion.div
            style={{
              position: "absolute",
              bottom: 20,
              right: 20,
              borderRadius: 10,
              backgroundColor: "#fff",
              width: 274,
              height: 320,
              padding: "20px 15px",
              boxShadow: "0 0 5px rgba(0,0,0,0.1)",
              overflowY: "auto",
            }}
            initial={{ width: 0, height: 0, opacity: 0 }}
            animate={{ width: 274, height: 320, opacity: 1 }}
            exit={{
              width: 0,
              height: 0,
              opacity: 0,
              transition: {
                opacity: { duration: 0.3, type: "spring" },
                width: { duration: 1, type: "spring" },
                height: { duration: 1, type: "spring" },
              },
            }}
            transition={{ duration: 0.5, type: "spring", staggerChildren: 0.5 }}
            onMouseEnter={() => setOpen(true)}
            onMouseLeave={() => setOpen(false)}
          >
            <motion.div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                gap: 8,
              }}
              initial={{ opacity: 0 }}
              animate={{
                opacity: 1,
                transition: { duration: 0.3, delay: 0.1 },
              }}
              exit={{ opacity: 0, transition: { duration: 0.1 } }}
            >
              <motion.p style={{ color: "#000", fontSize: 12, fontWeight: 700 }}>
                {t('helloJandi')}
              </motion.p>

              <motion.p style={{ color: "#000", fontSize: 12 }}>
                {t('wantToKnowHow')}
              </motion.p>

              <p style={{ color: "#000", fontSize: 12 }}>
                <strong>1. {t('tellUsWhatYouNeed')}</strong><br />
                {t('stepOne')}
              </p>

              <p style={{ color: "#000", fontSize: 12 }}>
                <strong>2. {t('findWhatYouNeed')}</strong><br />
                {t('personalizedOptions')}
              </p>

              <p style={{ color: "#000", fontSize: 12 }}>
                <strong>3. {t('organizeYourService')}</strong><br />
                {t('organizeDetails')}
              </p>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      <motion.div
        style={{ cursor: "pointer", zIndex: 999 }}
        initial={{ scale: 1.05 }}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
        transition={{ type: "spring" }}
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
        onClick={() => setOpen((prevState) => !prevState)}
      >
        <JandiSymbol style={{ width: 55, height: 55 }} />
      </motion.div>
    </motion.div>
  );
};

export default JandiHelp;
